<!-- 流程审核操作 -->
<template>
  <div>
    <el-dialog title="质量复查" center :visible.sync="reviewDataBox" append-to-body>
      <el-form :model="sendDataInfo" label-position="top">
        <el-form-item label="质量复查意见">
          <el-radio-group v-model="sendDataInfo.ssmType">
            <el-radio-button :label="1">合格</el-radio-button>
            <el-radio-button :label="0">不合格</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="后续处理" v-if="sendDataInfo.ssmType == 0">
          <el-radio-group v-model="sendDataInfo.ssmMode">
            <el-radio-button :label="1">退货</el-radio-button>
            <el-radio-button :label="0">销毁</el-radio-button>
            <el-radio-button :label="2">待处理</el-radio-button>
          </el-radio-group>
          <!-- <p style="color: #e90;">退货将会自动转入不合格！</p> -->
        </el-form-item>
        <el-form-item label="质量复查备注">
          <el-input type="textarea" placeholder="请输入内容" v-model="sendDataInfo.ssmRemark" maxlength="200" show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reviewDataBox = false">取 消</el-button>
        <el-button type="primary" @click="submitDataAction()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="质量复查流程" center :visible.sync="reviewProcessBox" append-to-body top="2vh">
      <div class="reviewProcessBox">
        <el-timeline>
          <el-timeline-item v-for="(nodeValue,nodeKey) in reviewNodeList" :key="nodeKey" :timestamp="$common.getLocalTime(nodeValue.startTime)" placement="top">
            <el-card>
              <h4>{{nodeValue.taskName}}</h4>
              <p>操作人：{{nodeValue.assigneeName}}</p>
              <p>审核意见：{{nodeValue.ssmRemark ? nodeValue.ssmRemark :'暂无信息'}}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reviewProcessBox = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: "substopselling",
  // props:['formData'],
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      reviewDataBox: false,
      reviewProcessBox: false,
      sendDataInfo: {
        ssmType: 1,
        ssmMode: 1,
        ssmId: "",
        ssmRemark: "",
      },
      reviewNodeList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    openBox(cate, keyId = "") {
      if (cate == 0) {
        this.sendDataInfo.ssmRemark = "";
        this.sendDataInfo.ssmType = 1;
        this.sendDataInfo.ssmId = keyId;
        this.reviewDataBox = true;
      } else {
        this.getTaskReviewHistory(keyId);
      }
    },

    // 获取任务审核历史
    async getTaskReviewHistory(id) {
      let responseData = await this.$http.getTaskReviewHistory({
        businessKey: id,
      });
      if (responseData.status == 200) {
        this.reviewProcessBox = true;
        this.reviewNodeList = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 核查停售信息
    async submitDataAction() {
      let responseData = await this.$http.stopscheckStop(this.sendDataInfo);
      if (responseData.status == 200) {
        this.$message({
          type: "success",
          message: "操作成功",
        });

        this.reviewDataBox = false;
        this.$parent.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.dialog_content {
  height: 50vh;
  overflow-y: auto;
}
</style>